<ngb-alert type="danger">
  {{ 'error' | portalTranslate }}
</ngb-alert>
